import React from 'react'
import { Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom';

const DisplayCreateSubscriptionModal = ({ handleClose }) => {
    const history = useHistory();
    return (
        <>
            <Modal.Header style={{ borderBottom: "none", background: "transparent", position: "relative", minHeight: 0 }}>
                <button
                    type="button"
                    aria-label="Close"
                    onClick={handleClose}
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: "#0f4e71",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: 30,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        cursor: "pointer",
                        zIndex: 2
                    }}
                >
                    &times;
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column align-items-center justify-content-center bg-white p-4">
                    <div className="d-flex flex-column align-items-center text-center" style={{ maxWidth: "400px" }}>
                        {/* Info Icon */}
                        <div
                            className="d-flex align-items-center justify-content-center rounded-circle mb-4"
                            style={{
                                width: "80px",
                                height: "80px",
                                backgroundColor: "#f59e0b",
                            }}
                        >
                            <i className="fas fa-info text-white" style={{ fontSize: "40px" }}></i>
                        </div>
                        <p
                            className="mb-4"
                            style={{
                                color: "#4b5563",
                                fontSize: "18px",
                                lineHeight: "1.6",
                            }}
                        >
                            You do not have an active subscription.
                        </p>

                        {/* Action Buttons */}
                        <div className="d-flex flex-column w-100 gap-3">
                            <button
                                type="button"
                                className="btn text-white fw-medium"
                                style={{
                                    backgroundColor: "#0f4e71",
                                    borderColor: "#0f4e71",
                                    padding: "16px 24px",
                                    fontSize: "18px",
                                    borderRadius: "8px",
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.backgroundColor = "#0a3a56"
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.backgroundColor = "#0f4e71"
                                }}
                                onClick={() => {
                                    handleClose();
                                    setTimeout(() => {
                                        history.push('/hospital/subscription/subscriptionPackage');
                                        window.location.replace('/hospital/subscription/subscriptionPackage');
                                    }, 400);
                                }}
                            >
                                Click to Subscribe
                            </button>

                        </div>
                    </div>
                </div>
            </Modal.Body>


        </>
    )
}

export default DisplayCreateSubscriptionModal
